module.exports = __webpack_public_path__ + "static/media/bang3.64dc4879.mp3";